import logoHorizontal from '@locaveri/ui/assets/logo-horizontal.svg?url'
import logoMark from '@locaveri/ui/assets/logo-mark.svg?url'
import logoMonoBlack from '@locaveri/ui/assets/logo-mono-black.svg?url'
import type { ReactElement } from 'react'

import { useTheme } from '@/components/theme/theme-context'
import { cn } from '@/lib/utils'

/**
 * Logo oficial da Locaveri (21/10/2026).
 *
 * A versão branco+amarelo é para fundo escuro. No tema claro ela sumiria (o
 * "loca" é branco), então trocamos pela monocromática preta — a mesma usada em
 * contrato e PDF. A arte vem toda de `@locaveri/ui/assets`, gerada do PDF
 * oficial por `packages/ui/scripts/logo-oficial.py`: aqui não existe cópia.
 *
 * `h-10` e não os `h-6` do provisório: o oficial é 3:1 (o provisório era 5:1),
 * e na mesma altura as letras ficariam com 14 px.
 */
export function BrandLogo({ className }: { readonly className?: string }): ReactElement {
  const { tema } = useTheme()

  return (
    <img
      src={tema === 'light' ? logoMonoBlack : logoHorizontal}
      alt="Locaveri"
      className={cn('h-10 w-auto select-none', className)}
      draggable={false}
    />
  )
}

/** Marca compacta (o carro), para a sidebar em modo trilho. */
export function BrandMark({ className }: { readonly className?: string }): ReactElement {
  return (
    <img
      src={logoMark}
      alt="Locaveri"
      className={cn('size-8 select-none rounded-md', className)}
      draggable={false}
    />
  )
}
